var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
/** @jsx jsx */


import { memo } from "react";
import { jsx } from "theme-ui";
import { Image } from "theme-ui";
import useTheme from "../../useTheme";
import { DENSITIES } from "../constants";
import { getSrcWithParameters } from "./helpers";

var CloudFlareImage = function CloudFlareImage(_a) {
  var alt = _a.alt,
      className = _a.className,
      _b = _a.dpr,
      dpr = _b === void 0 ? 1 : _b,
      _c = _a.fit,
      fit = _c === void 0 ? "scale-down" : _c,
      _d = _a.format,
      format = _d === void 0 ? "auto" : _d,
      _e = _a.gravity,
      gravity = _e === void 0 ? "auto" : _e,
      _f = _a.metadata,
      metadata = _f === void 0 ? "none" : _f,
      onerror = _a.onerror,
      _g = _a.quality,
      quality = _g === void 0 ? 85 : _g,
      sharpen = _a.sharpen,
      src = _a.src,
      width = _a.width,
      height = _a.height;
  var theme = useTheme().theme;

  if (!src) {
    return null;
  }

  var maxWidth = Array.isArray(width) ? Math.max.apply(Math, width.map(function (w) {
    return Number(w);
  })) : width;
  var maxHeight = Array.isArray(height) ? Math.max.apply(Math, height.map(function (w) {
    return Number(w);
  })) : height;
  var defaultParameters = {
    dpr: dpr,
    fit: fit,
    format: format,
    gravity: gravity,
    metadata: metadata,
    onerror: onerror,
    quality: quality,
    sharpen: sharpen,
    width: maxWidth,
    height: maxHeight
  }; // Density-based srcSet

  var srcSet = DENSITIES.map(function (density) {
    return getSrcWithParameters(src, __assign(__assign({}, defaultParameters), {
      dpr: density
    })) + " " + density + "x";
  }).join(", "); // Breakpoint-based srcSet

  if (Array.isArray(width)) {
    var srcMap_1 = {};
    width.forEach(function (w, wIndex) {
      DENSITIES.forEach(function (density) {
        var nextSrc = getSrcWithParameters(src, __assign(__assign({}, defaultParameters), {
          width: Number(w),
          height: Number(Array.isArray(height) ? height[wIndex] : height),
          dpr: density
        }));
        srcMap_1[Number(w) * density + "w"] = nextSrc;
      });
    });
    srcSet = Object.keys(srcMap_1).map(function (descriptorKey) {
      return srcMap_1[descriptorKey] + " " + descriptorKey;
    }).join(", ");
  }

  var defaultSrc = getSrcWithParameters(src, defaultParameters);
  var sizes = Array.isArray(width) ? __spreadArray([], theme.breakpoints, true).reverse().map(function (breakpoint, index) {
    return "(min-width: " + breakpoint + ") " + width.slice(1).reverse()[index] + "px";
  }).concat(width[0] + "px").join(", ") : undefined;
  return jsx("picture", null, jsx("source", {
    srcSet: srcSet,
    sizes: sizes
  }), jsx(Image, {
    variant: "poster",
    alt: alt,
    className: className,
    loading: "lazy",
    src: defaultSrc,
    srcSet: srcSet,
    sizes: sizes,
    draggable: false,
    width: maxWidth,
    height: maxHeight
  }));
};

export default memo(CloudFlareImage);